<template>
  <div>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Meeting Tasks</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- FILTER -->
        <v-flex xs12 sm12 lg12>
          <v-card elevation-5 dark>
            <v-card-title class="title">Filters</v-card-title>
            <v-layout ma-2>
              <v-flex lg6 xs6 sm6 mr-2>
                <v-combobox
                  v-model="selectedOpsManager"
                  label="Select system user"
                  :items="opsManagerList"
                  item-text="FullName"
                  item-value="ID"
                  @change="checkSelectedOpsManager()"
                  :disabled="opsManagerList.length == 0"
                ></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDateFormatted"
                      label="Start Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="startDate = parseStartDate(startDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu
                  ref="menu1"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDateFormatted"
                      label="End Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="endDate = parseEndDate(endDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                  <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout justify-end ma-2 row>
              <download-excel
                ref="downloadExcelRef"
                style="height:0px; opacity:0;"
                :data="excelData"
                :fields="excelFields"
                :name="fileName"
              ></download-excel>
              <v-btn flat outline @click="filterItems()">Filter</v-btn>
              <v-btn flat outline @click="clearFilter()">Clear Filter</v-btn>
              <v-btn flat outline @click="triggerExcel()">Export</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
        <v-layout row wrap ma-2>
          <v-layout ma-2>
            <v-flex xs3>
              <h3>Meeting Tasks</h3>
            </v-flex>
          </v-layout>
          <v-container>
            <v-layout mr-2>
              <v-spacer></v-spacer>
              <v-flex xs4>
                <v-text-field
                  append-icon="search"
                  v-model="search"
                  placeholder="Search meeting tasks"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-flex d-flex lg12 sm12 xs12>
              <v-data-table
                class="table"
                :headers="meetingTaskHeaders"
                :items="meetingTaskItems"
                :rows-per-page-items="[50, 75, 100]"
                :search="search"
              >
                <template v-slot:items="props">
                  <td>{{ props.index+1 }}</td>
                  <td class="text-xs-left">{{ props.item.Date }}</td>
                  <td class="text-xs-left">{{ props.item.SystemUserFullName }}</td>
                  <td class="text-xs-left">{{ props.item.Name }}</td>
                  <td class="text-xs-left">{{ props.item.Complete }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import Widget from "./Widget.vue";
import DataTable from "./DataTable.vue";
import TimeLine from "./TimeLine.vue";
import LocationStatistic from "./LocationStatistic.vue";
import SiteViewStatistic from "./SiteViewStatistic.vue";
import TotalEarningsStatistic from "./TotalEarningsStatistic.vue";
import moment from "moment";
import JWT from "jsonwebtoken";

export default {
  data() {
    return {
      tmp: [],
      selectedOpsManager: null,
      opsManagerList: [],
      role: null,
      userID: 0,
      startDate: null,
      endDate: null,
      startDateFormatted: this.formatStartDate(
        new Date().toISOString().substr(0, 10)
      ),
      endDateFormatted: this.formatEndDate(
        new Date().toISOString().substr(0, 10)
      ),
      menu1: false,
      menu2: false,
      CheckInsForToday: 0,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      customerItems: [],
      selectedCustomer: null,
      venueItems: [],
      selectedVenue: null,
      meetingTaskItems: [],
      search: null,
      meetingTaskHeaders: [
        {},
        {
          text: "Date",
          value: "Date",
          align: "left",
          sortable: true
        },
        {
          text: "For User",
          value: "SystemUserFullName",
          align: "left",
          sortable: true
        },
        {
          text: "Task",
          value: "Name",
          align: "left",
          sortable: true
        },
        {
          text: "Complete",
          value: "Complete",
          align: "left",
          sortable: true
        }
      ],
      excelFields: {
        Date: "Date",
        "For User": "SystemUserFullName",
        Task: "Name",
        Complete: "Complete"
      },
      excelData: [],
      fileName: null
    };
  },
  components: {
    Widget,
    DataTable,
    TimeLine,
    LocationStatistic,
    SiteViewStatistic,
    TotalEarningsStatistic
  },
  computed: {
    computedDateFormatted() {
      return this.formatStartDate(this.startDate);
      return this.formatEndDate(this.endDate);
    }
  },
  watch: {
    startDate(val) {
      this.startDateFormatted = this.formatStartDate(this.startDate);
    },
    endDate(value) {
      this.endDateFormatted = this.formatEndDate(this.endDate);
    }
  },
  mounted() {
    let self = this;
    let tokenDecoded = JWT.decode(localStorage.accessToken);
    console.log("[TOKEN DECODED]", tokenDecoded);

    self.userID = localStorage.getItem("USER_ID");
    console.log("USER_ID", self.userID);
    self.role = localStorage.getItem("Role");
    console.log("ROLE", self.role);

    var date = new Date();
    self.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
      .toISOString()
      .substr(0, 10);
    self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .substr(0, 10);

    self.FetchOpsManagers();
    self.FetchAllMeetingTasks();
  },
  methods: {
    FetchAllMeetingTasks() {
      let self = this;
      self.meetingTaskItems = [];

      self
        .get(
          `MeetingTask/GetAllForReport?startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log(r.data);
          r.data.forEach(meeting => {
            if (meeting.Date != null) {
              meeting.Date = moment(meeting.Date).format("YYYY-MM-DD hh:mm:ss");
            }

            if (meeting.SystemUserFullName == null) {
              meeting = null;
            }
            self.meetingTaskItems.push(meeting);
          });
          //self.meetingTaskItems = r.data;
        });
    },
    FetchOpsManagers() {
      let self = this;

      self.get(`SystemUser/getAll`).then(r => {
        console.log("[Ops-manager LIST]", r.data);
        self.opsManagerList = r.data;
      });
    },
    checkSelectedOpsManager() {
      let self = this;

      self.$nextTick(() => {
        console.log("selected ops-manager", self.selectedOpsManager);
      });
    },
    GetAllBySystemUser() {
      let self = this;

      self.meetingTaskItems = [];
      self
        .get(
          `MeetingTask/GetAllForReportBySystemUser?systemUserID=${self.selectedOpsManager.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          r.data.forEach(meeting => {
            if (meeting.Date != null) {
              meeting.Date = moment(meeting.Date).format("YYYY-MM-DD hh:mm:ss");
            }

            if (meeting.SystemUserFullName == null) {
              meeting = null;
            }
            self.meetingTaskItems.push(meeting);
          });
        });
    },
    filterItems() {
      let self = this;
      if (self.selectedOpsManager.ID != null) {
        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Filtering items...");
        console.log("SELECTED DATES", self.startDate, self.endDate);
        self.menu2 = false;
        self.GetAllBySystemUser();
        setTimeout(() => {
          self.$refs.Loader.hide();
        }, 2000);
      }
    },
    clearFilter() {
      let self = this;
      self.meetingTaskItems = [];
      self.selectedOpsManager = null;
    },
    triggerExcel() {
      let self = this;

      self.fileName = "Meeting-Tasks-" + self.today;
      self.excelData = self.meetingTaskItems;
      var vueJsonExcel = self.$refs.downloadExcelRef;
      vueJsonExcel.$el.click();
    },
    // DATE FILTERING
    parseDate(date) {
      let self = this;
      console.log("PARSED DATE", date);
    },
    filterByDate() {
      let self = this;
      var labels = [];
      var data = [];

      console.log("[FILTER START DATE]", self.startDate);
      console.log("[FILTER END DATE]", self.endDate);
    },
    formatStartDate(startDate) {
      if (!startDate) return null;

      const [year, month, day] = startDate.split("-");
      return `${month}/${day}/${year}`;
    },
    formatEndDate(endDate) {
      if (!endDate) return null;

      const [year, month, day] = endDate.split("-");
      return `${month}/${day}/${year}`;
    },
    parseStartDate(startDate) {
      if (!startDate) return null;

      const [month, day, year] = startDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseEndDate(endDate) {
      if (!endDate) return null;

      const [month, day, year] = endDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style>
</style>